module.exports = __webpack_public_path__ + "img/SL-M-120-160.ac300402.svg";